import { call, takeLatest } from "redux-saga/effects";
import { FAQ_LIST } from "../actions/types";
import { FaqApi } from "../apis/faqApi";

export function* faqListWorker(action) {
  try {
    const res = yield call(FaqApi, {});
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      "data": {
        message: "Something went wrong"
      }
    })
  }
}

export function* faqListWatcher() {
  yield takeLatest(FAQ_LIST, faqListWorker);
}
